'use client';

import { ReactNode } from 'react';
import { CardContainer } from '@/components/templates/CardContainer/CardContainer';
import { useWindowSize } from '@/hooks';
import { breakpointValues } from '@/theme/breakpoint';

interface ResultsContainerProps {
  variant?: 'long';
  children?: ReactNode;
}

export function ResultsContainer({ variant, children }: ResultsContainerProps) {
  const [width] = useWindowSize();

  return (
    <CardContainer
      maxColumns={
        variant === 'long' || width < breakpointValues.lgValue ? 1 : 2
      }
    >
      {children}
    </CardContainer>
  );
}
